<script setup>

    import { defineProps, defineEmits } from 'vue'

    const props = defineProps(['tabs', 'modelValue'])

    const emit = defineEmits(['update:modelValue'])

    function onChange(index) {
        emit('update:modelValue', index)
    }
</script>

<template>
    <div>
        <div class="">
            <div class="border-b border-gray-200">
                <nav class="-mb-px flex flex-wrap space-x-2 sm:space-x-8" aria-label="Tabs">
                    <button v-for="tab in tabs" :key="tab.name"  @click="onChange(tab.id)" :disabled="tab.disabled"
                        :class="[props.modelValue === tab.id ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-700 hover:text-blue-700 hover:border-gray-300', 
                            tab.disabled ? 'text-gray-300 hover:text-gray-300 hover:border-transparent': '',
                            'whitespace-nowrap pt-2 pb-4 px-1 border-b-2 font-medium text-xs sm:text-sm']"
                        :aria-current="props.modelValue === tab.id ? 'page' : undefined">{{ tab.name }}</button>

                    <div class="grow"></div>
                    <div class="flex gap-x-2 pb-2 mt-2 sm:mt-0 grow justify-end" id="tabButtons"></div>
                </nav>
            </div>
        </div>
    </div>
</template>